import { Controller } from "@hotwired/stimulus"

/**
 * Program Filter Stimulus Controller
 * 
 * Handles dynamic showing/hiding of enrollment status selector
 */
export default class extends Controller {
  static targets = [
    "programSelect", 
    "additionalFiltersContainer",
    "statusSelect",
    "dateSelect"
  ]

  static values = {
    selectedEnrollmentStatus: String,
    selectedEnrollmentDate: String
  }

  declare readonly programSelectTarget: HTMLSelectElement
  declare readonly additionalFiltersContainerTarget: HTMLElement
  declare readonly statusSelectTarget: HTMLSelectElement
  declare readonly dateSelectTarget: HTMLSelectElement

  declare readonly selectedEnrollmentStatusValue: string
  declare readonly selectedEnrollmentDateValue: string

  connect(): void {
    // Initialize with existing values if any
    this.initializeFromFormValues()
  }

  programChanged(): void {
    const programId = this.programSelectTarget.value
    if (programId) {
      this.showAdditionalFilters()
    } else {
      this.hideAdditionalFilters()
    }
  }

  private initializeFromFormValues(): void {
    // Check if program is already selected
    const programId = this.programSelectTarget.value
    if (programId) {
      this.showAdditionalFilters()
    } else {
      this.hideAdditionalFilters()
    }
  }

  private showAdditionalFilters(): void {
    this.additionalFiltersContainerTarget.style.display = 'block'
  }

  private hideAdditionalFilters(): void {
    this.additionalFiltersContainerTarget.style.display = 'none'
    // Clear the additional filter selections when hiding
    this.statusSelectTarget.value = ''
    this.dateSelectTarget.value = ''
  }
}
